import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Spinner from "./Spinner";

export default function LoadingScreen() {
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <Spinner loadingText={"Wird geladen..."}></Spinner>
      </Backdrop>
    </div>
  );
}
